import { CartItemOption } from '../features/cart/cartModels';
import { Customization, RestaurantMenuItem } from '../features/restaurant/restaurantModels';

export interface Category {
  [key: string]: {
    quantity: number;
    subCategories: any;  
    categoryId?:string
  };
}
export interface SubCategory {
  [key: string]: {
    quantity: number;
    image: string;
    imageType: string;
  };
}

const isTruthyFeatureFlag = (value: any) => {
  if (value === undefined || value === null) return false;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return ["true", "1", "yes", "y"].includes(normalized);
  }
  return Boolean(value);
};

// cdBuzzerEnabled: CD check-in goes to the Buzzer picker page.
export const isCdBuzzerPickerEnabled = (restaurantDetails?: any) =>
  isTruthyFeatureFlag(restaurantDetails?.uiFeatureFlags?.cdBuzzerEnabled);

// cdQSR (only when buzzer is off): CD check-in goes to the Dine In / Takeaway
// picker page instead, then follows the same pay-first flow without a buzzer.
export const isCdQsrFlowEnabled = (restaurantDetails?: any) =>
  isTruthyFeatureFlag(restaurantDetails?.uiFeatureFlags?.cdQSR) &&
  !isCdBuzzerPickerEnabled(restaurantDetails);

// Pay-first contactless (QSR) session: buzzer flow OR cdQSR flow. All menu /
// cart / payment / place-order code keys off this together with the
// CONTACTLESS_BUZZER_FLOW session flag.
export const isBuzzerFlowEnabled = (restaurantDetails?: any) =>
  isCdBuzzerPickerEnabled(restaurantDetails) || isCdQsrFlowEnabled(restaurantDetails);

export const CD_QSR_ORDER_TYPE_STORAGE_KEY = "CONTACTLESS_QSR_ORDER_TYPE";
export type CdQsrOrderTypeGroup = "D" | "P";

// Dine In ('D') / Takeaway ('P') picked on the cdQSR page; null outside a cdQSR session.
export const getCdQsrOrderTypeGroup = (restaurantDetails?: any): CdQsrOrderTypeGroup | null => {
  if (!isCdQsrFlowEnabled(restaurantDetails)) return null;
  try {
    if (localStorage.getItem("CONTACTLESS_BUZZER_FLOW") !== "1") return null;
    const stored = localStorage.getItem(CD_QSR_ORDER_TYPE_STORAGE_KEY);
    return stored === "D" || stored === "P" ? stored : null;
  } catch {
    return null;
  }
};

// orderTypeId for a CD / pay-first session: pickup when Takeaway was picked on
// the cdQSR page, otherwise dine-in. Totals and create-order must both use this.
export const getCdSessionOrderTypeId = (restaurantDetails?: any, fallbackOrderTypeId?: any) => {
  const typeGroup = getCdQsrOrderTypeGroup(restaurantDetails) ?? "D";
  return (
    restaurantDetails?.orderTypes?.find((orderType: any) => orderType?.typeGroup === typeGroup)
      ?.id || fallbackOrderTypeId
  );
};

export const getMerchantTokenKey = (restaurantDetails?: any): string | undefined => {
  const classData = restaurantDetails?.paymentProvider?.classData;
  if (!classData) return undefined;
  try {
    const parsed = typeof classData === "string" ? JSON.parse(classData) : classData;
    return parsed?.onClickCheckoutAPIKey || undefined;
  } catch {
    return undefined;
  }
};

// export const getAvailableCatgorySubCategory = (
//   restaurantMenuDetails: RestaurantMenuItem[]
// ) => {
//   let categoryTypes: Category = {};
//   let subCategoryTypes: SubCategory = {};

//   if (restaurantMenuDetails) {
//     restaurantMenuDetails
//       ?.filter((menuItem: RestaurantMenuItem) => menuItem.display == 1) // Display Filter
//       .map((menuItem: RestaurantMenuItem) => {
//         // Load Category Map
//         if (menuItem.category && menuItem.subCategory) {
//           if (Object.keys(categoryTypes).includes(menuItem.category)) {
//             // Update Number of Items in that Category
//             categoryTypes[menuItem.category].quantity =
//               categoryTypes[menuItem.category].quantity + 1;

//             // Add Subcategory to Category
//             if (
//               !categoryTypes[menuItem.category].subCategories.includes(
//                 menuItem.subCategory
//               )
//             ) {
//               categoryTypes[menuItem.category].subCategories.push(
//                 menuItem.subCategory
//               );
//             }
//           } else {
//             // Create New Category
//             categoryTypes[menuItem.category] = {
//               quantity: 1,
//               subCategories: [menuItem.subCategory],
//             };
//           }
//         } else if (menuItem.subCategory) {
//           //Category Null - Add SubCategory as Category
//           let OTHERS = "Custom";
//           if (Object.keys(categoryTypes).includes(menuItem.subCategory)) {
//             // Increase Quantity
//             categoryTypes[menuItem.subCategory].quantity =
//               categoryTypes[menuItem.subCategory].quantity + 1;
//           } else {
//             // Create New Category
//             categoryTypes[menuItem.subCategory] = {
//               quantity: 1,
//               subCategories: [],
//             };
//           }
//         }

//         // Load Subcategory Map
//         if (
//           Object.keys(subCategoryTypes).includes(menuItem.subCategory) &&
//           menuItem.category
//         ) {
//           subCategoryTypes[menuItem.subCategory] = {
//             image:
//               menuItem.subCategoryImg && menuItem.subCategoryImg.length > 0
//                 ? menuItem.subCategoryImg
//                 : "",
//             imageType:
//               menuItem.subCategoryImgType &&
//               menuItem.subCategoryImgType.length > 0
//                 ? menuItem.subCategoryImgType
//                 : "",
//             quantity: subCategoryTypes[menuItem.subCategory].quantity + 1,
//           };
//         } else {
//           if (menuItem.subCategory) {
//             subCategoryTypes[menuItem.subCategory] = {
//               image: menuItem.subCategoryImg || "",
//               imageType: menuItem.subCategoryImgType || "",
//               quantity: 1,
//             };
//           }
//         }
//       });
//   }

//   return { categoryTypes, subCategoryTypes };
// };

export const getAvailableCatgorySubCategory1 = (
  restaurantMenuDetails: RestaurantMenuItem[]
) => {
  let categoryTypes: Category = {};
  let subCategoryTypes: SubCategory = {};
 
  if (restaurantMenuDetails) {
    restaurantMenuDetails
      ?.filter((menuItem: RestaurantMenuItem) => menuItem.display == 1) // Display Filter
      .map((menuItem: RestaurantMenuItem) => {
        // Load Category Map
        if (menuItem.category && menuItem.subCategory) {
          if (Object.keys(categoryTypes).includes(menuItem.category)) {
            // Update Number of Items in that Category
            categoryTypes[menuItem.category].quantity =
              categoryTypes[menuItem.category].quantity + 1;
 
            // Add Subcategory to Category
            if (
              !categoryTypes[menuItem.category].subCategories.includes(
                menuItem.subCategory
              )
            ) {
              categoryTypes[menuItem.category].subCategories.push(
                menuItem.subCategory
              );
            }
          } else {
            // Create New Category
            categoryTypes[menuItem.category] = {
              quantity: 1,
              subCategories: [menuItem.subCategory],
            };
          }
        } else if (menuItem.subCategory) {
          //Category Null - Add SubCategory as Category
          let OTHERS = "Custom";
          if (Object.keys(categoryTypes).includes(menuItem.subCategory)) {
            // Increase Quantity
            categoryTypes[menuItem.subCategory].quantity =
              categoryTypes[menuItem.subCategory].quantity + 1;
          } else {
            // Create New Category
            categoryTypes[menuItem.subCategory] = {
              quantity: 1,
              subCategories: [],
            };
          }
        }
 
        // Load Subcategory Map
        if (
          Object.keys(subCategoryTypes).includes(menuItem.subCategory) &&
          menuItem.category
        ) {
          subCategoryTypes[menuItem.subCategory] = {
            image:
              menuItem.subCategoryImg && menuItem.subCategoryImg.length > 0
                ? menuItem.subCategoryImg
                : "",
            imageType:
              menuItem.subCategoryImgType &&
              menuItem.subCategoryImgType.length > 0
                ? menuItem.subCategoryImgType
                : "",
            quantity: subCategoryTypes[menuItem.subCategory].quantity + 1,
          };
        } else {
          if (menuItem.subCategory) {
            subCategoryTypes[menuItem.subCategory] = {
              image: menuItem.subCategoryImg || "",
              imageType: menuItem.subCategoryImgType || "",
              quantity: 1,
            };
          }
        }
      });
  }

 
  return { categoryTypes, subCategoryTypes };
};
 
export const getAvailableCatgorySubCategory = (restaurantMenuDetails: RestaurantMenuItem[]) => {
  let categoryTypes: Category = {};
  let subCategoryTypes: SubCategory = {};

  if (restaurantMenuDetails) {

    restaurantMenuDetails
      ?.filter((menuItem: RestaurantMenuItem) => menuItem.display == 1 ) // Display Filter
      .map((menuItem: RestaurantMenuItem) => {
        // Load Category Map
        if (!menuItem.categories?.length) return;

        const activeCategories = menuItem.categories.filter((cat: any) => !cat?.isCategoryOff);
   
         
        activeCategories.forEach((Cat: any) => {
          // Case 1: Category + SubCategory
          if (Cat.categoryName && Cat.subCategoryName && !Cat?.isSubCategoryOff) {
  if (categoryTypes[Cat.categoryName]) {
    categoryTypes[Cat.categoryName].quantity += 1;

    const alreadyExists = categoryTypes[Cat.categoryName].subCategories.some(
      (sub: any) => sub.subCategoryName === Cat.subCategoryName
    );

    if (!alreadyExists) {
      categoryTypes[Cat.categoryName].subCategories.push({
        subCategoryName: Cat.subCategoryName,
        subCategorySortOrder: Cat.subCategorySortOrder,
      });
    }
  } else {
    categoryTypes[Cat.categoryName] = {
      quantity: 1,
      subCategories: [
        {
          subCategoryName: Cat.subCategoryName,
          subCategorySortOrder: Cat.subCategorySortOrder,
        },
      ],
      categoryId: Cat.categoryId,
    };
  }
}


          // Case 2: Category-only bucket (no subcategory mapping)
          else if (Cat.categoryName && !Cat.subCategoryName) {
            if (categoryTypes[Cat.categoryName]) {
              categoryTypes[Cat.categoryName].quantity += 1;
            } else {
              categoryTypes[Cat.categoryName] = {
                quantity: 1,
                subCategories: [],
                categoryId:Cat.categoryId

              };
            }
          }

          // Case 3: Only SubCategory → treat as Category
          // else if (Cat.subCategoryName) {
          //   if (categoryTypes[Cat.subCategoryName]) {
          //     categoryTypes[Cat.subCategoryName].quantity += 1;
          //   } else {
          //     categoryTypes[Cat.subCategoryName] = {
          //       quantity: 1,
          //       subCategories: [],
          //     };
          //   }
          // }

          // -------- SubCategory Map --------
          if (Cat.subCategoryName && !Cat?.isSubCategoryOff) {
            if (subCategoryTypes[Cat.subCategoryName]) {
              subCategoryTypes[Cat.subCategoryName].quantity += 1;
            } else {
              subCategoryTypes[Cat.subCategoryName] = {
                image: '',
                imageType: '',
                quantity: 1,
              };
            }
          }
        });
    
      });
     
  }
  
  

  return { categoryTypes, subCategoryTypes };
};
export const getDecimalPlacedPriceString = (price: number | string) => {
  if (typeof price == 'number') {
    return price.toFixed(2);
  } else {
    return parseFloat(price).toFixed(2);
  }
};

// export const getTwoDecimalValue =(value:any)=>{
//   return Math.trunc(Number(value) * 100)/100;
// }

export const getTwoDecimalValue = (value: any) => {
  const fullValue = value * 100;
  return parseFloat((Math.trunc(fullValue) / 100)?.toString()).toFixed(2) as any;
};

export const getTruncTwoDecimalValue = (value: any) => {
  return parseFloat((Math.trunc(value * 100) / 100)?.toString()).toFixed(2);
};

export const getDecimalPlacedPrice = (price: number | string) => {
  const str = price.toString().includes('.')
    ? price.toString().split('.')[0] + '.' + price.toString().split('.')[1].slice(0, 2)
    : price;
  if (typeof price == 'number') {
    return Number(str);
  } else {
    return Number(str);
  }
};

export const getCustomisationType = (customisation: Customization) => {
  if (customisation.minRequired == 0 && customisation.maxRequired == 0) {
    return 'view';
  }
  if (customisation.minRequired == customisation.maxRequired) {
    return 'single';
  }
  if (customisation.minRequired < customisation.maxRequired) {
    return 'multiple';
  }
  return 'view';
};

export const getDefaultCustomisations = (itemCustomisations: Customization[]) => {
  let addedTypes: string[] = [];
  let defCustomisations: CartItemOption[] = [];
  itemCustomisations?.map((customisation: Customization) => {
    if (
      getCustomisationType(customisation) == 'single' &&
      !addedTypes.includes(customisation.typeId)
    ) {
      defCustomisations.push({
        modifierOptionId: customisation.modifierOptionId,
        modifier: customisation.type,
        optionName: customisation.optionName,
        price: customisation.price + '',
        quantity: '1',
        typeId: '',
      });
      addedTypes.push(customisation.typeId);
    }
  });
  return defCustomisations;
};



const groupCategories = (categories: any[]) => {
  const grouped = categories.reduce((acc: any, item: any) => {
    const {
      categoryId,
      categoryName,
      isCategoryOff,
      inactiveUntil,
      inactiveUntilTime,
      subCategoryId,
      subCategoryName,
      isSubCategoryOff,
      subCategoryInactiveUntil,
      subCategoryInactiveUntilTime,
    } = item;

    // If category not already added
    if (!acc[categoryId]) {
      acc[categoryId] = {
        categoryId,
        categoryName,
        isCategoryOff,
        inactiveUntil,
        inactiveUntilTime,
        subCategories: []
      };
    }

    // If subcategory exists → push into subCategories
    if (subCategoryId) {
      acc[categoryId].subCategories.push({
        subCategoryId,
        subCategoryName,
        isSubCategoryOff,
        subCategoryInactiveUntil,
        subCategoryInactiveUntilTime
      });
    }

    return acc;
  }, {});

  return Object.values(grouped);
};




const getNextUnavailableTime = (data: any[]) => {

  // Check category level first
  for (const category of data) {
    if (category.inactiveUntil && category.inactiveUntilTime) {
      return category.inactiveUntilTime;
    }
  }

  //  If no category inactive → check subcategory level
  for (const category of data) {
    for (const sub of (category.subCategories || [])) {
      if (sub.subCategoryInactiveUntil && sub.subCategoryInactiveUntilTime) {
        return sub.subCategoryInactiveUntilTime;
      }
    }
  }

  return null;
};

const getUnavailableCategories = (data: any[],restaurantMenuCategories:any) => {

const sortOrderMap = restaurantMenuCategories.reduce((acc: any, cat: any) => {
  acc[cat.categoryId] = cat.sortOrder;
  return acc;
}, {});
  return data
    .filter(category => {
      // Category unavailable
      if (category.inactiveUntil) return true;
      // Any subcategory unavailable
      return category.subCategories?.some(
        (sub: any) => sub.subCategoryInactiveUntil === true
      );
    })
    .map(category => ({
      ...category,
      subCategories: [...(category.subCategories || [])]
        .sort((a: any, b: any) =>
          (a.subCategorySortOrder || 0) - (b.subCategorySortOrder || 0)
        )
    }))
    .sort((a, b) =>
      (sortOrderMap[a.categoryId] || 0) -
      (sortOrderMap[b.categoryId] || 0)
    );
};


export  const calculateMenuUnavailableDetails = (data: any,restaurantMenuCategories:any) => {
    const categories = data?.categories || [];
const groupCategoriesData=groupCategories(categories);
const filterREdUnavaible=getUnavailableCategories(groupCategoriesData,restaurantMenuCategories)
const getNextUnavailableTimedata=getNextUnavailableTime(filterREdUnavaible)


  return getNextUnavailableTimedata
  };
